/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PutSelectedViewPathParams = NonNullable<operations['putSelectedView']['parameters']['path']>;

export type PutSelectedViewRequestBody = OperationRequestBodyContent<operations['putSelectedView']>;

export interface Input extends PutSelectedViewPathParams {
  apiVersion?: string;
  body: PutSelectedViewRequestBody;
}

export async function putSelectedView(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PUT('/internal/profile/selected-view/{projKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
